// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { AppComponent } from '@app/app.component';

@Injectable()
export class LMAppComponentService {

  private appComponent: AppComponent = null;

  public getAppComponent(): AppComponent {
    return this.appComponent;
  }

  public setAppComponent(appComponent: AppComponent) {
    this.appComponent = appComponent;
  }
}
